<template>
  <section
    v-editable="blok"
    :data-section-uid="blok._uid"
    :class="[paddingBottom, paddingTop]"
    :style="{
      background: gradient,
    }"
  >
    <div
      class="container container--section"
      :class="{ 'container--narrow': blok.narrow }"
    >
      <StoryblokComponent
        v-for="childBlok in blok.blocks"
        :key="childBlok._uid"
        :blok="childBlok"
      />
    </div>
  </section>
</template>

<script lang="ts" setup>
import type { SbSectionGradientStoryblok } from '@/types'
interface Props {
  blok: SbSectionGradientStoryblok
}
const props = defineProps<Props>()

const paddingBottom = computed(() => {
  return `pb-${props.blok.padding_bottom}` || 'pb-0'
})
const paddingTop = computed(() => {
  return `pt-${props.blok.padding_top}` || 'pt-0'
})
const gradient = computed(() => {
  return `linear-gradient(to ${props.blok.direction}, ${props.blok.gradient_start.color}, ${props.blok.gradient_end.color})`
})
</script>
